import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Flame } from "lucide-react";
import api from "../lib/api";
import { useCart } from "../context/CartContext";

const Promo = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const { setDiscount } = useCart();
  const [message, setMessage] = useState("Unlocking your code...");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/discounts/validate", { code, subtotal: 0 })
      .then(({ data }) => {
        setDiscount({ code: data.code, type: data.type, value: data.value });
        setMessage(`Code ${data.code} locked in. Redirecting to the store...`);
        setTimeout(() => navigate("/shop"), 1400);
      })
      .catch(() => {
        setMessage("That promo link has expired. Redirecting to the store...");
        setTimeout(() => navigate("/shop"), 1800);
      });
  }, [code, navigate, setDiscount]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-4 text-center" data-testid="promo-page">
      <Flame className="w-10 h-10 text-[#E05A36] animate-pulse" />
      <p className="font-display font-bold uppercase tracking-tight text-xl" data-testid="promo-message">{message}</p>
    </div>
  );
};

export default Promo;
